import { createFlowAnalyticsTracker } from "../../utils/flowAnalytics/createFlowAnalyticsTracker.js";
import kftRegFlowStepRegistry from "./kftRegFlowStepRegistry.js";

export { FLOW_ANALYTICS_ACTIONS } from "../../utils/flowAnalytics/createFlowAnalyticsTracker.js";

export const createKftRegFlowAnalytics = ({
  getSearchId,
  getSteps,
  getFlowInstance,
  entryFlow = "kftreg",
}) =>
  createFlowAnalyticsTracker({
    getSearchId,
    getSteps,
    getFlowInstance,
    entryFlow,
    stepRegistry: kftRegFlowStepRegistry,
  });
